import ServerSettings, {ServerSettingsFieldType} from "../../../../gd/settings/server-settings/server-settings"
import {NavigationSectionType} from "../../../../model2/navigation/@const"
import {MyWorkViewName} from "../../../../../app/home/my-work/common/@const"

// const debug = "UserSettingsViewsMyWork"
const debug = false

export default class UserSettingsViewsMyWork extends ServerSettings {

    public companyId        : ID
    public currentView      : any
    public viewsSettings    : any
    public displayIn        : NavigationSectionType

    public addedViews       : JSONArray

    constructor(config: any) {

        const fieldsConfig = {
            'companyId': {
                type            : ServerSettingsFieldType.VALUE,
                defaultValue    : gd.companyId
            },

            'currentView': {
                type            : ServerSettingsFieldType.VALUE,
                // defaultValue    : gd.const.myWork.viewType.TODAY, // Stranno chto do etogo ne vizvalo oshibku. Takoy ViewType uje ne izpolzuetsya
                defaultValue    : MyWorkViewName.MY_WORK_VIEW_BOARD,
            },

            'viewsSettings': {
                type            : ServerSettingsFieldType.VALUE,
                defaultValue    : {},
            },

            'displayIn': {
                type            : ServerSettingsFieldType.OPTION,
                options         : [NavigationSectionType.HOME, NavigationSectionType.MORE, NavigationSectionType.NAVIGATION_PANEL],
                defaultValue    : NavigationSectionType.HOME
            },

            'addedViews': {
                type            : ServerSettingsFieldType.VALUE,
                defaultValue    : [],
            }
        }

        super(config, fieldsConfig);

        this.companyId      = this.initValue('companyId')

        // default current view
        this.currentView    = this.initValue('currentView')

        if (this.currentView === 'today' /*gd.const.myWork.viewType.TODAY*/) {
            this.currentView = MyWorkViewName.MY_WORK_VIEW_BOARD
        }

        this.viewsSettings  = this.initValue('viewsSettings')
        this.displayIn      = this.initValue('displayIn')

        this.addedViews     = this.initValue('addedViews')
    }


    toJson() {
        const result: any = {}

        // companyId is the identity key of each collection item, so it must
        // always be serialized. valueToJson() drops fields equal to their
        // default, and companyId's default is gd.companyId (the active company),
        // which would drop it for the currently active company's model.
        result.companyId = this.companyId

        this.valueToJson(result, 'currentView')
        this.valueToJson(result, 'viewsSettings')
        this.valueToJson(result, 'displayIn')

        this.valueToJson(result, 'addedViews')

        debug && console.log(debug, 'toJson', result, this)

        return result
    }
}
